import React, { useEffect, useState } from 'react';

interface LoadingIndicatorProps {
  message?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  message = 'Generating campaign proposal...'
}) => {
  const [dotStates, setDotStates] = useState([false, false, false]);

  useEffect(() => {
    // Animate dots with staggered timing
    const interval = setInterval(() => {
      setDotStates(prev => {
        const next = [...prev];
        const activeIndex = prev.findIndex(v => v);

        if (activeIndex === -1) {
          // Start animation - activate first dot
          next[0] = true;
        } else if (activeIndex < 2) {
          // Move to next dot
          next[activeIndex] = false;
          next[activeIndex + 1] = true;
        } else {
          // Reset and start over
          next[2] = false;
          next[0] = true;
        }

        return next;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-2 text-sm text-ink-2">
      <div className="flex gap-1">
        <div
          className={`w-2 h-2 rounded-full transition-all duration-200 ${
            dotStates[0] ? 'bg-navy scale-125' : 'bg-blue-300 scale-75 opacity-40'
          }`}
        ></div>
        <div
          className={`w-2 h-2 rounded-full transition-all duration-200 ${
            dotStates[1] ? 'bg-navy scale-125' : 'bg-blue-300 scale-75 opacity-40'
          }`}
        ></div>
        <div
          className={`w-2 h-2 rounded-full transition-all duration-200 ${
            dotStates[2] ? 'bg-navy scale-125' : 'bg-blue-300 scale-75 opacity-40'
          }`}
        ></div>
      </div>
      <span className="font-medium">{message}</span>
    </div>
  );
};
